/* pk-carousel — horizontal drag/scroll gallery (IcebergGallery port).
   Native scroll + click-drag pan (>4px suppresses the trailing click),
   arrow buttons scroll ~85% of viewport, left arrow fades in after scroll. */
class PKCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-pk-scroller]');
    this.leftBtn = this.querySelector('[data-pk-prev]');
    this.rightBtn = this.querySelector('[data-pk-next]');
    if (!this.scroller) return;

    this.leftBtn?.addEventListener('click', () => this.scrollByDir(-1));
    this.rightBtn?.addEventListener('click', () => this.scrollByDir(1));
    this.scroller.addEventListener('scroll', () => this.syncArrows(), { passive: true });
    this.scroller.addEventListener('mousedown', (e) => this.dragStart(e));
    // never let links/images hijack the pan with a native drag
    this.scroller.addEventListener('dragstart', (e) => e.preventDefault());
    this.syncArrows();
  }

  scrollByDir(dir) {
    this.scroller.scrollBy({
      left: dir * Math.min(820, this.scroller.clientWidth * 0.85),
      behavior: 'smooth',
    });
  }

  syncArrows() {
    const el = this.scroller;
    const atStart = el.scrollLeft <= 4;
    const atEnd = el.scrollLeft >= el.scrollWidth - el.clientWidth - 4;
    this.toggleArrow(this.leftBtn, !atStart);
    this.toggleArrow(this.rightBtn, !atEnd);
  }

  toggleArrow(btn, show) {
    if (!btn) return;
    btn.style.opacity = show ? '1' : '0';
    btn.style.pointerEvents = show ? 'auto' : 'none';
    btn.tabIndex = show ? 0 : -1;
  }

  dragStart(e) {
    if (e.button !== 0) return;
    e.preventDefault(); // suppress native link/image drag so the pan wins
    const el = this.scroller;
    const start = { x: e.pageX, sl: el.scrollLeft, moved: false };
    el.style.cursor = 'grabbing';
    const move = (ev) => {
      const dx = ev.pageX - start.x;
      if (Math.abs(dx) > 4) start.moved = true;
      el.scrollLeft = start.sl - dx;
      ev.preventDefault();
    };
    const up = () => {
      el.style.cursor = 'grab';
      document.removeEventListener('mousemove', move);
      document.removeEventListener('mouseup', up);
      if (start.moved) {
        const block = (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          document.removeEventListener('click', block, true);
        };
        document.addEventListener('click', block, true);
        setTimeout(() => document.removeEventListener('click', block, true), 80);
      }
    };
    document.addEventListener('mousemove', move);
    document.addEventListener('mouseup', up);
  }
}
customElements.define('pk-carousel', PKCarousel);
